<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin-top: 20px;">Global admin setup</h1>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="!isStatusCreated" class="container">
            <div class="alert alert-primary" role="alert">
                Global admin is the highest privilage role in TransparentChoice.
                Users in this role can manage organizations and other users.
                Please create one before you will create workspace and invite users.
                It is always good to have at least two users with that role to avoid an issue of single point of failure, so after setting up an instance you can nominate second one..
                After creating an admin will receive system generated password which should be changes to user provided one ASAP.
            </div>

            <div class="form-group">
                <label for="Email">Email:</label>
                <input v-model="email" type="email" class="form-control" placeholder="Work email of an admin">
                <ValidationError context="Email" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="FirstName">First name:</label>
                <input v-model="firstName" type="text" class="form-control" placeholder="First name of an admin">
                <ValidationError context="FirstName" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="LastName">Last name:</label>
                <input v-model="lastName" type="text" class="form-control" placeholder="Last name of an admin">
                <ValidationError context="LastName" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group form-check">
                <input v-model="setInitialPassword" type="checkbox" class="form-check-input" id="setInitialPassword">
                <label class="form-check-label" for="setInitialPassword">Set initial password manually</label>
            </div>

            <div v-show="setInitialPassword">
                <div class="form-group">
                    <label for="Password">Initial password:</label>
                    <input v-model="password" type="password" class="form-control">
                    <ValidationError context="Password" :errors="validationErrors"></ValidationError>
                </div>

                <div class="form-group" v-show="password">
                    <label for="PasswordConfirmation">Initial password confirmation:</label>
                    <input v-model="passwordConfirmation" type="password" class="form-control" :class="{ 'is-invalid': passwordConfirmationInvalid }">
                    <div class="invalid-feedback">Initial password confirmation doesn't match</div>
                </div>
            </div>

            <button v-show="isStatusNotCreated" @click="handleCreateUserCommandV1" type="button" class="btn btn-primary btn-lg" :disabled="passwordConfirmationInvalid">Create</button>
            <button v-show="isStatusCreating" type="button" class="btn btn-primary btn-lg" disabled>Creating...</button>
        </div>

        <div v-else class="container">
            <h1>Congratulations!</h1>
            <h3>Global admin account was created and password was sent on email {{email}}</h3>
            <a class="btn btn-primary btn-lg" href="/#/" role="button">Sign-in</a>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import VuePageQueries from "@Organizations/Users/Domain/queries-vue-component";
    import VuePageCommands from "@Organizations/Users/Domain/commands-vue-component";
    import "@common/Components/ValidationError.vue";

    enum Status {
        NotCreated,
        Creating,
        Created
    }

    @Component
    export default class CreateGlobalAdminPage extends mixins(PageBase, VuePageQueries, VuePageCommands) {
        email = '';
        firstName = '';
        lastName = '';
        password = ''
        passwordConfirmation = ''
        setInitialPassword = false
        status: Status = Status.NotCreated;

        get isStatusNotCreated() { return this.status == Status.NotCreated }
        get isStatusCreating() { return this.status == Status.Creating }
        get isStatusCreated() { return this.status == Status.Created }

        mounted() {
            this.setTitle('Global admin setup');
        }

        get passwordConfirmationInvalid(): boolean {
            if (this.setInitialPassword) {
                return this.passwordConfirmation && (this.passwordConfirmation != this.password)
            }
            return false
        }

        handleCreateUserCommandV1() {
            this.status = Status.Creating;
            this.$clearValidationErrors();
            this.invokeCreateUserCommandV1('0', null, this.email, this.firstName, this.lastName, true, false, false, this.setInitialPassword, this.password);
        }

        succeedCreateUserCommandV1() {
            this.status = Status.Created;
        }

        invalidCreateUserCommandV1(status) {
            this.$pushValidationErrors(status.ValidationErrors);
            this.status = Status.NotCreated;
        }

        failedCreateUserCommandV1(status) {
            this.status = Status.NotCreated;
        }
    }
</script>

<style scoped>
</style>
